// @ts-nocheck
import { get, post } from "@insite/client-framework/Services/ApiService";
import { TrackingInfoModel } from "@store/Framework/Types/TrackingInfoModel";

const serviceUri = "/api/v1/ordertracking/";

export async function getTrackingInfo(erpOrderNumber: string) {
    const trackingInfo = await get<TrackingInfoModel>(`${serviceUri}${erpOrderNumber}`);
    return trackingInfo;
}

export async function updateShippingNotification(
    erpOrderNumber: string,
    useNotification: boolean,
    notificationEmail: string,
) {
    let callUri = `${serviceUri}${erpOrderNumber}/${useNotification}`;
    if (notificationEmail) {
        callUri += `/${notificationEmail}`;
    }
    const updatedNotification = await post<boolean>(callUri);
    return updatedNotification;
}

export async function updateCustomerPreferencesShippingNotification(
    billToId: string, // in classic, this is System.Guid!
    useNotification: boolean,
    notificationEmail: string,
) {
    let callUri = `${serviceUri}/updatecustomerpreferencesshippingnotification/${billToId}/${useNotification}`;
    if (notificationEmail) {
        callUri += `/${notificationEmail}`;
    }
    const updateCustomerPreference = await post(callUri);
    return updateCustomerPreference;
}
